<template>
  <div class="chat-progress">
    <div class="border" :style="borderWidth"></div>
    <div class="pips">
      <div
        v-for="(pip, index) in total"
        class="pip"
        :key="`pip-${index}`"
        :class="{'is-active': index < step}"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChatProgress',

  props: {
    step: Number,
    total: Number
  },

  computed: {
    borderWidth() {
      let width = (100 / this.total) * (this.step - 1) + '%'
      return `width: ${width}`
    }
  }
}
</script>

<style lang="sass">
@import '../../stylesheets/base/variables'
@import '../../stylesheets/base/theme'

$max: 6

.chat-progress
  position: relative
  opacity: 0
  animation: fadeIn .5s 1s ease-in
  animation-fill-mode: forwards

  .border
    opacity: 0.5
    width: 0
    transition: width .2s ease-in-out
    height: 1px
    position: absolute
    top: 50%
    left: 5px

    @include themify($themes)
      background: themed('color-primary')

  .pip
    width: 8px
    height: 8px
    margin-right: 8px
    opacity: 0.5
    border-radius: 50%
    transition: all .2s .3s ease-in-out

    @include themify($themes)
      background: themed('color-secondary')

    &.is-active
      opacity: 1
      transform: scale(1.3)

      @include themify($themes)
        background: themed('color-primary')

  .pips
    display: flex
    position: relative
</style>
